module.exports = __webpack_public_path__ + "img/workContents03_sp_03.26648988.png";